import "./App.css";
import Navbar from "./components/Navbar/navbar";
import Sections from "./components/Sections/sections";

function App() {
  return (
    <div className="App">
      {/* <List /> */}
      <Navbar />
      <Sections />
    </div>
  );
}

export default App;
